import { EboNameObject } from '../base-classes/ebo-name-object';
import { Hub } from '../places/hub/hub';
import { Division } from './division';

export class DivisionHub extends EboNameObject {
  hubID: number;
  hub: Hub;
  divisionID: string;
  division: Division;

  constructor(jsonData: Partial<DivisionHub>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.hub) this.hub = new Hub(jsonData.hub);
      if (jsonData.division) this.division = new Division(jsonData.division);
    }
  }

  toShortString(format: string): string {
    if (format == 'hubToShortString') {
      return this.hub ? this.hub.toShortString() : null;
    }
    return null;
  }
}
